// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Contact from "./contact.js"
import ContactAddress from "./contact-address.js"
import PhotoSessionCsv from "./photo-session-csv.js"

const modelClassData = {
  "attributes": {
    "allow_download_of_photos": {
      "column": {
        "default": false,
        "name": "allow_download_of_photos",
        "null": false,
        "type": "boolean"
      },
      "name": "allow_download_of_photos",
      "selected_by_default": null,
      "translated": null
    },
    "contact_address_id": {
      "column": {
        "default": null,
        "name": "contact_address_id",
        "null": true,
        "type": "uuid"
      },
      "name": "contact_address_id",
      "selected_by_default": null,
      "translated": null
    },
    "customer_id": {
      "column": {
        "default": null,
        "name": "customer_id",
        "null": false,
        "type": "uuid"
      },
      "name": "customer_id",
      "selected_by_default": null,
      "translated": null
    },
    "ends_at": {
      "column": {
        "default": null,
        "name": "ends_at",
        "null": false,
        "type": "datetime"
      },
      "name": "ends_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "kmd_request_number": {
      "column": {
        "default": null,
        "name": "kmd_request_number",
        "null": true,
        "type": "string"
      },
      "name": "kmd_request_number",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_type": {
      "column": {
        "default": null,
        "name": "photo_session_type",
        "null": false,
        "type": "string"
      },
      "name": "photo_session_type",
      "selected_by_default": null,
      "translated": null
    },
    "photos_available_at": {
      "column": {
        "default": null,
        "name": "photos_available_at",
        "null": true,
        "type": "datetime"
      },
      "name": "photos_available_at",
      "selected_by_default": null,
      "translated": null
    },
    "starts_at": {
      "column": {
        "default": null,
        "name": "starts_at",
        "null": false,
        "type": "datetime"
      },
      "name": "starts_at",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "translated_photo_session_type": {
      "column": null,
      "name": "translated_photo_session_type",
      "selected_by_default": null,
      "translated": null
    },
    "book_front_page_photo_path": {
      "column": null,
      "name": "book_front_page_photo_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "PhotoSession",
  "collectionKey": "photo_sessions",
  "collectionName": "photo_sessions",
  "i18nKey": "photo_session",
  "camelizedLower": "photoSession",
  "name": "PhotoSession",
  "nameDasherized": "photo-session",
  "pluralName": "photo_sessions",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "book_front_page_photo_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "book_front_page_photo_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "book_front_page_photo_attachment"
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "contact_address_id",
      "name": "contact_address",
      "macro": "belongs_to",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "ContactPhotoSessionCurrent",
      "collectionName": "contact_photo_session_currents",
      "foreignKey": "photo_session_id",
      "name": "contact_photo_session_currents",
      "macro": "has_many",
      "resource_name": "ContactPhotoSessionCurrent",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "customer_id",
      "name": "customer",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSessionCsv",
      "collectionName": "photo_session_csvs",
      "foreignKey": "photo_session_id",
      "name": "photo_session_csvs",
      "macro": "has_many",
      "resource_name": "PhotoSessionCsv",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContact",
      "through": "photo_session_groups"
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_id",
      "name": "photo_session_groups",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "allow_download_of_photos",
      "column": {
        "default": false,
        "name": "allow_download_of_photos",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "contact_address_id",
      "column": {
        "default": null,
        "name": "contact_address_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "customer_id",
      "column": {
        "default": null,
        "name": "customer_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "ends_at",
      "column": {
        "default": null,
        "name": "ends_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "kmd_request_number",
      "column": {
        "default": null,
        "name": "kmd_request_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_contact_address_id",
      "column": {
        "default": null,
        "name": "old_contact_address_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_customer_id",
      "column": {
        "default": null,
        "name": "old_customer_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "photo_session_type",
      "column": {
        "default": null,
        "name": "photo_session_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "photos_available_at",
      "column": {
        "default": null,
        "name": "photos_available_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "starts_at",
      "column": {
        "default": null,
        "name": "starts_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "contact_address_id",
      "name": "contact_address",
      "macro": "belongs_to",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "customer_id",
      "name": "customer",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "PhotoSessionCsv",
      "collectionName": "photo_session_csvs",
      "foreignKey": "photo_session_id",
      "name": "photo_session_csvs",
      "macro": "has_many",
      "resource_name": "PhotoSessionCsv",
      "through": null
    }
  ],
  "paramKey": "photo_session",
  "primaryKey": "id"
}

/** Frontend model for PhotoSession. */
export default class PhotoSession extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  allowDownloadOfPhotos() {
    return this.readAttributeUnderscore("allow_download_of_photos")
  }

  /** @returns {boolean} */
  hasAllowDownloadOfPhotos() {
    const value = this.allowDownloadOfPhotos()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  contactAddressId() {
    return this.readAttributeUnderscore("contact_address_id")
  }

  /** @returns {boolean} */
  hasContactAddressId() {
    const value = this.contactAddressId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  customerId() {
    return this.readAttributeUnderscore("customer_id")
  }

  /** @returns {boolean} */
  hasCustomerId() {
    const value = this.customerId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  endsAt() {
    return this.readAttributeUnderscore("ends_at")
  }

  /** @returns {boolean} */
  hasEndsAt() {
    const value = this.endsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  kmdRequestNumber() {
    return this.readAttributeUnderscore("kmd_request_number")
  }

  /** @returns {boolean} */
  hasKmdRequestNumber() {
    const value = this.kmdRequestNumber()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSessionType() {
    return this.readAttributeUnderscore("photo_session_type")
  }

  /** @returns {boolean} */
  hasPhotoSessionType() {
    const value = this.photoSessionType()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  photosAvailableAt() {
    return this.readAttributeUnderscore("photos_available_at")
  }

  /** @returns {boolean} */
  hasPhotosAvailableAt() {
    const value = this.photosAvailableAt()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  startsAt() {
    return this.readAttributeUnderscore("starts_at")
  }

  /** @returns {boolean} */
  hasStartsAt() {
    const value = this.startsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedPhotoSessionType() {
    return this.readAttributeUnderscore("translated_photo_session_type")
  }

  /** @returns {boolean} */
  hasTranslatedPhotoSessionType() {
    const value = this.translatedPhotoSessionType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  bookFrontPagePhotoPath() {
    return this.readAttributeUnderscore("book_front_page_photo_path")
  }

  /** @returns {boolean} */
  hasBookFrontPagePhotoPath() {
    const value = this.bookFrontPagePhotoPath()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createPhotoSessionGroupsWithContactsFromCsv(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_photo_session_groups_with_contacts_from_csv",
        primaryKey: this.primaryKey(),
        collectionName: "photo_sessions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateBook(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_book",
        primaryKey: this.primaryKey(),
        collectionName: "photo_sessions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateStickers(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_stickers",
        primaryKey: this.primaryKey(),
        collectionName: "photo_sessions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateZipFileForKmd(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_zip_file_for_kmd",
        primaryKey: this.primaryKey(),
        collectionName: "photo_sessions",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact-address.js").default | null} */
  contactAddress() {
    return this._readBelongsToReflection({modelClass: ContactAddress, reflectionName: "contact_address"})
  }

  /** @returns {Promise<import("./contact-address.js").default | null>} */
  loadContactAddress() {
    if (!("contactAddressId" in this)) throw new Error("Foreign key method wasn't defined: contactAddressId")

    const id = this.contactAddressId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact_address",
        model: this,
        modelClass: ContactAddress
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact-address.js").default | null>} */
  ensureContactAddressLoaded() {
    return this.ensureAssociationLoaded("contact_address")
  }

  /** @returns {import("./contact.js").default | null} */
  customer() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "customer"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadCustomer() {
    if (!("customerId" in this)) throw new Error("Foreign key method wasn't defined: customerId")

    const id = this.customerId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "customer",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureCustomerLoaded() {
    return this.ensureAssociationLoaded("customer")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo-session-csv.js").default>} */
  photoSessionCsvs() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_session_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "photo_session_csvs",
        model: this,
        modelClass: PhotoSessionCsv
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-session-csv.js").default>>} */
  loadPhotoSessionCsvs() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_session_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "photo_session_csvs",
        model: this,
        modelClass: PhotoSessionCsv
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-session-csv.js").default>>} */
  ensurePhotoSessionCsvsLoaded() {
    return this.ensureAssociationLoaded("photo_session_csvs")
  }
}
